@switch (headlineNodeType()) {
  @case ('h1') {
    <h1 [ngClass]="cssClass()" [style]="style()">
      <ng-container [ngTemplateOutlet]="content" />
    </h1>
  }
  @case ('h2') {
    <h2 [ngClass]="cssClass()" [style]="style()">
      <ng-container [ngTemplateOutlet]="content" />
    </h2>
  }
  @case ('h3') {
    <h3 [ngClass]="cssClass()" [style]="style()">
      <ng-container [ngTemplateOutlet]="content" />
    </h3>
  }
  @case ('h4') {
    <h4 [ngClass]="cssClass()" [style]="style()">
      <ng-container [ngTemplateOutlet]="content" />
    </h4>
  }
  @case ('h5') {
    <h5 [ngClass]="cssClass()" [style]="style()">
      <ng-container [ngTemplateOutlet]="content" />
    </h5>
  }
  @case ('h6') {
    <h6 [ngClass]="cssClass()" [style]="style()">
      <ng-container [ngTemplateOutlet]="content" />
    </h6>
  }
  @case ('p') {
    <p [ngClass]="cssClass()" [style]="style()">
      <ng-container [ngTemplateOutlet]="content" />
    </p>
  }
}
<ng-template #content>
  @if (iconClass()) {
    <i class="fas mr-1" [ngClass]="iconClass()" aria-hidden="true"></i>
  }
  @if (text()) {
    {{ text() | translate: textParams() }}
  }
  <ng-content />
</ng-template>
